<template>
  <ClModal v-model="active" :blur="true" :persistent="true">
    <v-card rounded class="rounded-xl">
      <div class="course-modal">
        <img src="../../../assets/images/courses/DoreIQSNohom1404-Small.jpg">
        <div class="col-two">
          <div class="course-modal-description p-4">
            <h3>دوره IQ نهم :</h3>
            <p>آموزش و تدريس فراتر از كتاب درسي
            </p>
            <p>كلاس‌هاي استعداد تحصيلي و استعداد تحليلي
            </p>
            <p>حل تست و آزمون براي آمادگي آزمون‌هاي ورودي مدارس برتر، تيزهوشان و نمونه دولتي
            </p>
            <p>حل تست‌هاي آزمون تيزهوشان، نمونه دولتي و مدارس برتر سال‌هاي گذشته
            </p>
            <p>زمان شروع دوره : ۱۳ مرداد
            </p>
          </div>
          <div class="btns-box">
            <a class="btn cl-btn cl-btn-blue "
               @click="gotoFilteredCourses('/courses?courses=418&grades=&lessons=&professors=')">نمایش
              دوره‌ها</a>
          </div>
        </div>
      </div>
    </v-card>
  </ClModal>
</template>

<script>
import ClModal from "@/components/common/ClModal.vue";

export default {
  name: "DoreJameDahom1404",
  components: {ClModal},
  props: ['activeCourse'],
  data() {
    return {
      active: false
    }
  },
  mounted() {
    this.active = true
  },
  methods: {
    gotoFilteredCourses(params) {
      this.$router.push(params)
    },
    close() {
      this.active = false;
    }
  },
  watch: {
    activeCourse() {
      this.active = true
    }
  }

}
</script>

<style scoped>
</style>
